// Foundations (Saturn): four-letter words score more.
import { ALIGNMENT_NUMBERS as N } from '../constants';
import type { AlignmentDef } from '../types';

export const foundations: AlignmentDef = {
  id: 'foundations',
  planet: 'saturn',
  name: 'Foundations',
  text: () => `${N.foundationsLength}-letter words score +${N.foundationsPercent}%.`,
  wordPercent: (c) => (c.nodes.length === N.foundationsLength ? N.foundationsPercent : 0),
};
